import mustache from "mustache";
import { IConnectRender } from "../../../../definitions/IConnectRender";
import { MonitoreoBrocaMapRender } from "./MonitoreoBrocaMapRender";
import { MonitoreoBrocaSemanaSelectorRender } from "./MonitoreoBrocaSemanaSelectorRender";
import template from "./monitoreoBrocaSplitMapTemplate.html";

mustache.parse(template);

/** Vista dividida de Monitoreo Broca: dos mapas independientes, cada uno con su
 *  propio selector de semana (año + semana), para comparar dos semanas lado a
 *  lado. Vive dentro de `MonitoreoBrocaSplitViewModalRender`. */
export class MonitoreoBrocaSplitMapRender implements IConnectRender {
  private readonly _mapA = new MonitoreoBrocaMapRender();
  private readonly _mapB = new MonitoreoBrocaMapRender();
  private readonly _selectorA = new MonitoreoBrocaSemanaSelectorRender(
    (semana) => this._mapA.setSemana(semana.registros),
  );
  private readonly _selectorB = new MonitoreoBrocaSemanaSelectorRender(
    (semana) => this._mapB.setSemana(semana.registros),
  );

  render(): string {
    return mustache.render(template, {
      selectorA: this._selectorA.render(),
      mapA: this._mapA.render(),
      selectorB: this._selectorB.render(),
      mapB: this._mapB.render(),
    });
  }

  connect(): void {
    this._selectorA.connect();
    this._mapA.connect();
    this._selectorB.connect();
    this._mapB.connect();

    // Sincroniza zoom/desplazamiento entre los dos mapas (comparar la misma
    // zona geográfica). `setView` no reemite, así que no hay loop A→B→A.
    this._mapA.setOnViewChange((center, zoom) => this._mapB.setView(center, zoom));
    this._mapB.setOnViewChange((center, zoom) => this._mapA.setView(center, zoom));
  }

  dispose(): void {
    this._selectorA.dispose();
    this._mapA.dispose();
    this._selectorB.dispose();
    this._mapB.dispose();
  }
}
